import type { ReactNode } from 'react';

/**
 * THE TOP OF A WORKING SCREEN: where am I, how does it stand, what do I do next.
 *
 * One title, one short line under it (a fact about this production, never a
 * paragraph about the product), and the actions on the right — at most ONE of
 * them primary. The project's own name, phase and plan are the shell's header
 * and are not repeated here.
 */
export function PageHeader({
  title,
  lede,
  status,
  actions,
  eyebrow,
  testId,
}: {
  title: ReactNode;
  lede?: ReactNode;
  status?: ReactNode;
  actions?: ReactNode;
  eyebrow?: ReactNode;
  testId?: string;
}) {
  return (
    <header className="ui-page-head" data-testid={testId}>
      <div className="ui-page-head-text">
        {eyebrow === undefined ? null : <p className="ui-eyebrow">{eyebrow}</p>}
        <div className="ui-page-head-title">
          <h2 className="dh">{title}</h2>
          {status}
        </div>
        {lede === undefined ? null : <p className="ui-page-head-lede">{lede}</p>}
      </div>
      {actions === undefined ? null : <div className="ui-page-head-actions">{actions}</div>}
    </header>
  );
}
